import { callGetExternalApi, callPutExternalApi } from '@ctn/axios-util';

import { type IEmisor } from '@/interfaces/model/emisor.interface';
import axiosInstance from '@/utils/axiosInterceptor';

type IEmisorParams = {
	nifEmisor?: string;
	idTipoSector?: number;
	provincia?: string;
};

const getBackendUrl = ({ nifEmisor, idTipoSector }: IEmisorParams) => ({
	GET_EMISOR: `/emisores/detalle/${nifEmisor}/${idTipoSector}`,
});

const getEmisor = async (payload: {
	nifEmisor: string;
	idTipoSector: number;
}) =>
	callGetExternalApi<IEmisor>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrl(payload).GET_EMISOR,
	});

const putEmisor = async (payload: IEmisor) =>
	callPutExternalApi<IEmisor>({
		axiosInstance,
		withCredentials: true,
		url: '/emisores',
		data: payload
	});

export {
	getEmisor,
	putEmisor
};